export default function TasksPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold tracking-tight">Tasks & Assignments</h1>
      <p className="text-muted-foreground">
        Manage assessment tasks and track completion status
      </p>
    </div>
  );
}
